<template>
  <div class="">
    <Form ref="achievementForm" :model="achievementForm" :rules="achievementRules" :label-width="80">
      <FormItem prop="AchievementName" class="margin-left-zero">
        <i-input
                v-model="achievementForm.AchievementName"
                type="text"
                placeholder="Achievement Name"
        ></i-input>
      </FormItem>
      <FormItem prop="Description" class="margin-left-zero">
        <Select v-model="language" filterable placeholder="Select language" style="width: 200px;margin-bottom: 8px;" class="right capitalize">
          <Option v-for="lang in UIlanguages" :value="lang.LanguageCode" :key="lang.LanguageCode" class="capitalize">{{ lang.LanguageName}}</Option>
        </Select>
        <Input v-model="description" type="textarea" placeholder="Description" :autosize="{minRows: 5,maxRows: 5}"></Input>
        <Button type="primary" class="right" style="margin-top: 16px;" v-if="description.length" @click="addUpdateDescription('create')" small ghost>Add description</Button>
        <Button type="success" class="right" style="margin-top: 16px;margin-right: 8px" v-if="activeDescription!=null" @click="addUpdateDescription('update')" small ghost>Update description</Button>
      </FormItem>
      <Table :columns="descColumns" :data="descriptionList" :row-class-name="DescRowClassName" ref="descriptionTable" class="white-table" v-if="descriptionList.length" @on-row-click="onDescRowClick" style="margin-bottom: 24px;">
        <div slot-scope="{ row, index }" slot="action">
          <Button type="error" size="small" @click="deleteDescription(index)">Delete</Button>
        </div>
      </Table>

      <Row type="flex" justify="center" :gutter="16">
        <i-col :xs="12" >
          <FormItem prop="Threshold" label="Threshold:">
            <InputNumber :min="0" v-model="achievementForm.Threshold"></InputNumber>
          </FormItem>
        </i-col>
        <i-col :xs="12" >
          <FormItem prop="IconID" label="Icon ID:">
            <InputNumber :min="0" v-model="achievementForm.IconID"></InputNumber>
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <Row type="flex" justify="center" :gutter="16" style="margin-top: 24px;">
      <i-col :xs="12" v-if="showUpdate">
        <Button long
                type="success"
                :loading="submitUpdateLoading"
                @click="handleCreateOrUpdate('update')"
        >       <span v-if="!submitUpdateLoading">Update achievement</span>
          <span v-else>Processing...</span>
        </Button>
      </i-col>
      <i-col :xs="12">
        <Button long
                type="primary"
                :loading="submitLoading"
                @click="handleCreateOrUpdate('create')"
        >       <span v-if="!submitLoading">Add achievement</span>
          <span v-else>Processing...</span>
        </Button>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow">
      <Icon type="ios-loading" size=32 class="spin-icon-load"></Icon>
    </Spin>
  </div>

</template>

<script>
  import { bus } from "../../main";
  import { addAchievement, updateAchievement, getAchievement } from "../../_services/achievement.service";
  import { getTrophies } from "../../_services";
  import { getSupportedLanguages } from "../../_services/language.service";

  export default {
    props:['achievements'],
    data() {
      const validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please fill in the achievement name.'));
        } else {
          let duplicateName=this.achievements.filter(({AchievementName})=>{
            return AchievementName===value
          })
          if(duplicateName.length){
            if(this.achievementForm._id){
              if(duplicateName.length>1){
                callback(new Error('Achievement name already exist.'));
              }else{
                if(duplicateName[0]._id!==this.achievementForm._id){
                  callback(new Error('Achievement name already exist.'));
                }else{
                  callback();
                }
              }
            }else{
              callback(new Error('Achievement name already exist.'));
            }
          }else{
            callback();
          }
        }
      };
      const validateDescripton = (rule, value, callback) => {
        if (!this.descriptionList.length) {
          callback(new Error('Please add achievement description.'));
        } else {
          callback();
        }
      };
      return {
        submitUpdateLoading:false,
        submitLoading:false,
        showUpdate:false,
        descColumns: [
          {
            title: "Language",
            key: "LanguageName",
            className: "capitalize",
            width:"150"
          },
          {
            title: "Description",
            key: "Description"
          },
          {
            title:" ",
            slot:"action",
            align:"right",
            width: "80"
          }
        ],
        language:"",
        description:"",
        descriptionList:[],
        activeDescription:null,
        achievementForm:{
          AchievementName: "",
          Description: {},
          Threshold: 0,
          IconID: 0,
        },
        currentUpdateData:{
          AchievementName: "",
          Description: {},
          Threshold: 0,
          IconID: 0,
        },
        achievementRules: {
          AchievementName: [
            { validator: validateName, trigger: 'blur' }
          ],
          Description: [
            { validator: validateDescripton, trigger: 'blur' }
          ],
        },
        listStyle: {
          width: '210px',
          height: '200px'
        },
        UIlanguages:[],
        spinShow:false,
      };
    },
    methods: {
      getUILanguageList() {
        this.dataLoading=true
        getSupportedLanguages().then(res=>{
          this.UIlanguages=res.data.data
          this.language=res.data.data[0].LanguageCode
        }).catch(err=>{
          bus.$emit('requestError',err)
        })
      },
      async addUpdateDescription(method){
        this.activeDescription=null
        let existingLang = this.descriptionList.filter(({LanguageCode}) => {
          return LanguageCode === this.language
        })
        let lang = Object.assign({},this.UIlanguages.filter(({LanguageCode}) => {
          return LanguageCode === this.language
        })[0])
        lang.Description = this.description
        if(method==="create"){
          if(existingLang.length){
            this.$Notice.error({
              title: 'Duplicate Language',
              desc: `Description for language <span class="capitalize">${existingLang[0].LanguageName}</span> already exist.`,
            });
          }else {
            this.descriptionList.push(lang)
            this.language = this.UIlanguages[0].LanguageCode
            this.description = ""
          }
        }else {
          this.descriptionList.splice(this.activeDescription,1,lang)
          this.language = this.UIlanguages[0].LanguageCode
          this.description = ""
        }
        await this.$refs.achievementForm.validateField('Description');
      },
      deleteDescription(index){
        this.descriptionList.splice(index,1)
        this.$refs.achievementForm.validateField('Description');
        this.activeDescription=null
      },
      onDescRowClick(data,index){
        if(this.activeDescription===index){
          this.activeDescription=null
        }else {
          this.activeDescription = index
          this.language = data.LanguageCode
          this.description = data.Description
        }
      },
      DescRowClassName(row, index) {
        if (index === this.activeDescription) {
          return 'active-table-row';
        }
        return '';
      },
      setUpdateData(data){
        let vm=this
        vm.spinShow=true
        if(this.currentUpdateData._id){
          vm.spinShow=false
          if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.achievementForm)){
            this.$Modal.confirm({
              title: 'Unsaved Changes',
              content: `Changes made on ${this.currentUpdateData.AchievementName} is not yet saved? Do you wish to save it first?`,
              okText: 'Save',
              cancelText: 'Discard',
              onOk:() => {
                this.handleCreateOrUpdate('update',data)
              },
              onCancel: () =>{
                this.getAchievementData(data)
                this.$emit('setActive',data)
              }
            });
          }else{
            this.getAchievementData(data)
            this.$emit('setActive',data)
          }
        }else {
          this.getAchievementData(data)
          this.$emit('setActive',data)
        }

      },
      getAchievementData(data){
        let vm=this
        vm.resetForm()

        getAchievement(data._id).then(async res=>{
          this.showUpdate=true
          let achievementData = Object.assign({},res.data.data)
          vm.achievementForm=data
          vm.achievementForm.Description={}
          Object.keys(achievementData.Description).forEach(key=>{
            let lang = Object.assign({},this.UIlanguages.filter(({LanguageCode}) => {
              return LanguageCode === key
            })[0])
            lang.Description = achievementData.Description[key]
            this.descriptionList.push(lang)
            vm.spinShow=false
          })
          this.currentUpdateData = Object.assign({},this.achievementForm)

        })
      },
      handleCreateOrUpdate(method,nextData) {
        if(method==='create' && this.achievementForm._id) {
          this.showUpdate=false
          delete this.achievementForm._id;
          this.$emit('setActive',null)
        }
        this.$refs.achievementForm.validate(valid => {
          if (valid) {
            this.descriptionList.map(desc=>{
              this.achievementForm.Description[desc.LanguageCode]=desc.Description
            })

            if(method==='create') {
              this.submitLoading=true
              addAchievement(this.achievementForm).then(res => {
                this.$Message.success(`${this.achievementForm.AchievementName} added to achievements!`);
                this.$emit('getAchievements')
                this.submitLoading = false
                this.resetForm()
              }).catch(err => {
                bus.$emit('requestError',err)
                this.submitLoading = false
                this.$Message.error('Failed to create achievement. Please try again later.')

              })
            }else{
              this.submitUpdateLoading=true
              updateAchievement(this.achievementForm._id,this.achievementForm).then(res => {
                this.$Message.success(`Successfully updated achievement ${this.achievementForm.AchievementName}!`);
                this.$emit('getAchievements')
                this.submitUpdateLoading = false
                this.currentUpdateData = Object.assign({},res.data.data)
                if(nextData){
                  this.getAchievementData(nextData)
                  this.$emit('setActive',nextData)
                }else {
                  this.$emit('setActive',null);
                  this.resetForm()
                }
              }).catch(err => {
                bus.$emit('requestError',err)
                this.submitUpdateLoading = false
                this.$Message.error('Failed to update achievement. Please try again later.')
              })
            }
          }
        });
      },
      resetForm(){
        this.showUpdate=false
        this.currentUpdateData={}
        this.achievementForm={
          AchievementName: "",
          Description: {},
          Threshold: 0,
          IconID: 0
        }
        this.language=this.UIlanguages[0].LanguageCode
        this.description=""
        this.descriptionList=[]
        this.activeDescription=null
        if(this.$refs.achievementForm) {
          this.$refs.achievementForm.resetFields();
        }
      }
    },
    mounted() {
      this.getUILanguageList()
    }
  };
</script>
<style>
  .margin-left-zero .ivu-form-item-content{
    margin-left: 0!important;
  }
</style>
